import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { useDashboard } from "context/DashboardContext";
const LogoutUser = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { resetDashboardState } = useDashboard();
  const handleLogout = () => {
    // Clear all stored data in local storage
    logout();
    resetDashboardState();
    // console.log("Cleared Data Successfully")

    // Redirect to the login page
    navigate("/authentication/sign-in");
  };

  // Call handleLogout when this component renders
  React.useEffect(() => {
    handleLogout();
  }, []);

  return null; // This component doesn't render anything
};

export default LogoutUser;
